/*
 * premierstreets
 * version 4.5
 * www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import {
    Component, Input, OnInit, ViewChild, PLATFORM_ID,
    Inject,
    Renderer2,
    HostListener,
    OnDestroy
} from '@angular/core';

import { isPlatformBrowser } from '@angular/common';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { Router } from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';
import { AppSettings, Settings } from '../../../app.settings';
import { Title } from '@angular/platform-browser';
import { OverlayReference } from '@angular/cdk/overlay/overlay-reference';
import { SlugifyPipe } from '../../pipes/slugify.pipe';
import { CommonSandbox } from '../../../../core/common/common.sandbox';
import { ListsService } from '../../../../core/lists/lists.service';
import { BookingModalComponent } from '../../../../default/pages/products/booking-modal/booking-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from '../../../../core/common/common.service';


@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    providers: [SlugifyPipe]
})

export class MenuComponent implements OnInit, OnDestroy {

    private _overlayRef: OverlayReference;
    @Input() categories: any;
    @Input() siteSettings: any;
    @Input() categoriesExpanded: any;
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    private brand: number;
    public clearBrand: string;
    public index: number;
    public hover: any;
    public categoryId: string;
    public categorylinkActive: string;
    public settings: Settings;
    public enteredButton = false;
    public isMatMenuOpen = false;
    public isMatMenu2Open = false;
    public prevButtonTrigger;
    public recheckIfInMenu: boolean;
    public activeSlug: any;
    public activeSubSlug: any;
    public showNotification: boolean = true;
    public marketplaces = [];
    public subscriptions = [];
    public vendorDetail = null;
    public vendor = null;
    public showServices = false;
    public currentUser = null;
    public dialogRef: any;
    public enableHomeBrowse: string = '1';


    constructor(public listSandbox: ListsSandbox,
        public listService: ListsService,
        public appSettings: AppSettings, private ren: Renderer2,
        @Inject(PLATFORM_ID) private platformId: Object,
        public commonSandbox: CommonSandbox,
        private titleService: Title,
        public dialog: MatDialog,
        public snackBar: MatSnackBar,
        public commonService: CommonService,
        public router: Router) {
        this.settings = this.appSettings.settings;
        if (isPlatformBrowser(this.platformId)) {
            const setTheme = localStorage.getItem('optionsTheme');
            this.settings.theme = setTheme;

        }
    }
    ngOnInit() {
        this.recheckIfInMenu = false;
        this.subscriptions.push(this.commonSandbox.vendorDetail$.subscribe((vendor: any) => {
            if (vendor) {
                this.vendorDetail = vendor;
            }
        }));
        console.log('*********settings', this.settings, this.siteSettings);
        this.subscriptions.push(this.commonSandbox.vendorDetail$.subscribe((vendor: any) => {
            if (vendor) {
                console.log("detail of vendor gvg");
                console.log(vendor);
                this.vendor = vendor;
            }
        }));


        if (isPlatformBrowser(this.platformId)) {
            this.currentUser = JSON.parse(localStorage.getItem('storeUser'));
        }

        const params: any = {};
        params.limit = '';
        params.offset = 0;
        params.keyword = '';
        params.sortOrder = '';
        params.vendorId = this.vendor.vendorId;

        // this.listService.getSubCategories(params).toPromise().then((response: any) => {

        // 	this.showServices = response.data.find(item => item.type == 1);
        // });
        console.log("this.vendor info");
        console.log(this.vendor);
        this.listService.getfreeService(params).toPromise().then((response: any) => {
            console.log("web resposne");
            console.log(response);
            this.showServices = response.status;
        });
        // this._overlayRef.hostElement.classList.add('mega-menus');
        
    this.commonService.getSiteSetting().toPromise().then((response: any) => {
        this.enableHomeBrowse = response.data.enableHomeBrowse;
    });
    }
    

    openBookingModal() {

        if (isPlatformBrowser(this.platformId)) {
            this.currentUser = JSON.parse(localStorage.getItem('storeUser'));
        }


        if (this.currentUser) {
            this.dialogRef = this.dialog.open(BookingModalComponent, {
                data: {
                    vendorId: this.vendor.vendorId,
                }
            });
            this.dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.snackBar.open('Booking Request sent successfully', '×', {
                        panelClass: 'error',
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        duration: 3000
                    });
                }
                console.log(`Dialog result: ${result}`);
            });
        } else {
            this.snackBar.open('Please setup an account so you can setup an appointment', '×', {
                panelClass: 'error',
                verticalPosition: 'top',
                horizontalPosition: 'right',
                duration: 3000
            });
        }
    }

    openMegaMenu() {


        const pane = document.getElementsByClassName('cdk-overlay-pane');
        [].forEach.call(pane, function (el) {
            if (el.children.length > 0) {
                if (el.children[0].classList.contains('mega-menu')) {
                    el.classList.add('mega-menu-pane');
                }
            }
        });

        const overlay = document.getElementsByClassName('cdk-overlay-connected-position-bounding-box');
        [].forEach.call(overlay, function (el) {
            if (el.children[0].classList.contains('mega-menu-pane')) {
                el.classList.add('mega-overlay');
            }
        });


    }

    over() {
        //this.trigger.closeMenu();
    }

    hideNotification() {
        this.showNotification = false;
    }

    /** index for selecting categories.
     * @param index from event
     * @param categoryId from event
     * **/
    indexData(index, id) {
        if (this.categories && this.categories[index] && this.categories[index].children && this.categories[index].children.length > 0) {
            this.index = index;
            this.categoryId = id;
            //  this.trigger.openMenu();
            this.openMegaMenu();
        } else {
            this.trigger.closeMenu();
            return;
        }
    }

    // Make category link active if category got selected
    linkActive(mainCategory, slug) {

        this.activeSubSlug = slug;
        this.activeSlug = mainCategory.categorySlug;
        this.categorylinkActive = this.categoryId;
        this.titleService.setTitle(mainCategory.name);
    }

    /**
     * calls listSandbox productFilterData and send the value
     * @param productFilter set default value getting from template file
     */
    sendUniqueId(productFilter) {
        this.listSandbox.productFilterData.next(productFilter);
    }

    // getcategoryId value
    getCategory(id) {
        const params: any = {};
        params.categoryId = id;
        this.listSandbox.getCategory(params);
    }

    // getChildCategory value
    getChildCategory(id) {
        const params: any = {};
        params.categoryId = id;
        this.listSandbox.getCategory(params);
    }

    setTitle(title) {
        if (title === 'All Products') {
            this.titleService.setTitle('All Products');
            this.activeSlug = 'All';
        } else if (title === 'Blogs') {
            this.titleService.setTitle(title);
            this.activeSlug = 'Blogs';
        } else if (title === 'Contacts') {
            this.titleService.setTitle(title);
            this.activeSlug = 'Contacts';
        } else if (title === 'Home') {
            this.titleService.setTitle(title);
            this.activeSlug = 'Home';
        } else if (title === 'Service') {
            this.activeSlug = 'Service';
        } else if (title === 'Refer a Friend') {
            this.titleService.setTitle(title);
            this.activeSlug = 'Refer a Friend';
        }
    }

    setMainTitle(index, category) {
        this.activeSlug = category.categorySlug;
        this.openMegaMenu();
        if (this.categories && this.categories[index] && this.categories[index].children && this.categories[index].children.length > 0) {
            this.index = index;
            this.categoryId = category.categoryId;
            //   this.trigger.openMenu();
        } else {
            // this.trigger.closeMenu();
            return;
        }
    }

    openResourceMenu(index, id) {
        if (this.categories && this.categories[index] && this.categories[index].children && this.categories[index].children.length > 0) {
            this.index = index;
            this.categoryId = id;
            setTimeout(() => {
                if (this.recheckIfInMenu === true) {
                    //    this.trigger.openMenu();
                    this.openMegaMenu();
                }
            }, 700);

            // this.trigger.openMenu();
            // this.openMegaMenu();
        } else {
            //     this.trigger.closeMenu();
            this.openMegaMenu();
            return;
        }
    }

    closeResourceMenu() {
        //   this.recheckIfInMenu = false;
        setTimeout(() => {
            if (this.recheckIfInMenu === false) {
                //  this.trigger.closeMenu();
            }
        }, 175);

    }

    ngOnDestroy() {
        this.activeSlug = '';
        this.subscriptions.forEach(item => item.unsubscribe());
        //   this.activeSlug.activeSubSlug = '';
    }
}
